import { Button } from '@medly-components/core';
import { TourDialogBox } from 'pages/Map/components/MapTour/MapTourDialogBox.styled';
import styled from 'styled-components';

export const TourConfirmationWrapper = styled(TourDialogBox)<{ fadeOut?: boolean }>`
    width: 31.2rem;
    position: fixed;
    right: 4rem;
    bottom: 11.2rem;
    z-index: 1;
    animation: ${({ fadeOut }) => (fadeOut ? 'fadeOut 0.3s linear' : '')};
    animation-fill-mode: forwards;
    @keyframes fadeOut {
        0% {
            opacity: 1;
            scale: 1;
        }
        99% {
            opacity: 0;
            scale: 1;
        }
        100% {
            opacity: 0;
            scale: 0;
        }
    }

    @media (max-width: ${({ theme }) => theme.breakpoints.S.max}px) {
        right: 2.4rem;
        max-width: calc(100% - 10.2rem);
    }

    ${Button.Style} {
        padding-left: 1.6rem;
        padding-right: 1.6rem;
        width: 100%;
    }
`;
